export default __webpack_public_path__ + "static/media/video.5c9a74d1.mp4";